import { tryParseLocaleRegion } from '@localization/safeIntl';
import { withWindow } from '@shared/utils/withWindow';

/** Countries where SMS price alerts are supported (messaging team footprint). */
const PRICE_ALERT_SUPPORTED_COUNTRIES: ReadonlySet<string> = new Set(['US']);

/**
 * Returns `true` when the guest's browser region explicitly indicates a country where
 * SMS price alerts are deliverable. Uses `tryParseLocaleRegion` to correctly parse
 * BCP 47 tags with script subtags (zh-Hans-US) and POSIX decorations, rather than
 * the resolved geo locale — `useGuestGeoLocale` normalizes unsupported regions
 * (en-IN, en-ZA) to the US default, and during SSR the missing browser signal also
 * defaults to US, both of which would incorrectly qualify non-US guests.
 *
 * Returns `false` during SSR and when the browser language has no region subtag
 * (e.g. plain "en") or is unparseable.
 */
export const usePriceAlertGeoSupported = (): boolean => {
  const browserLanguage = withWindow(w => w.navigator.language, undefined);
  const region = tryParseLocaleRegion(browserLanguage);

  return !!region && PRICE_ALERT_SUPPORTED_COUNTRIES.has(region);
};
